(() => {
  function initGrid(root) {
    if (!root || root.dataset.hpdInitialized === 'true') return;
    root.dataset.hpdInitialized = 'true';

    const cards = Array.from(root.querySelectorAll('[data-hpd-custom-card]'));
    const button = root.querySelector('[data-hpd-load-more]');
    const showing = root.querySelector('[data-hpd-showing]');
    if (!button || !cards.length) return;

    const batch = parseInt(root.dataset.batch || '8', 10);
    let visible = Math.min(parseInt(root.dataset.initial || '8', 10), cards.length);

    const update = (focusFirstNew = false) => {
      const oldVisible = visible;
      visible = Math.min(visible, cards.length);
      cards.forEach((card, i) => card.classList.toggle('hpd-custom-card--hidden', i >= visible));

      if (showing) {
        const text = showing.textContent.trim();
        const match = text.match(/^(.*?)(\d+)\s+(\S+)\s+(\d+)\s+(.*)$/);
        if (match) showing.textContent = `${match[1]}${visible} ${match[3]} ${cards.length} ${match[5]}`;
      }

      if (visible >= cards.length) button.hidden = true;
      if (focusFirstNew && cards[oldVisible]) {
        const focusTarget = cards[oldVisible].querySelector('a,button');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    };

    update(false);
    button.addEventListener('click', () => {
      visible = Math.min(visible + batch, cards.length);
      update(true);
    });
  }

  const initAll = () => document.querySelectorAll('[data-hpd-custom-grid]').forEach(initGrid);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
